import { memo, lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";

import Loading from "../components/custom/loading";

// auth

const SignIn = lazy(() => import("../views/auth/sign-in"));
const SignUp = lazy(() => import("../views/auth/sign-up"));
const PrivacyPolicy = lazy(() => import("../views/auth/PrivacyPolicy"));
// errors
const Error404 = lazy(() => import("../views/errors/error404"));
const Error500 = lazy(() => import("../views/errors/error500"));
const Maintenance = lazy(() => import("../views/errors/maintenance"));


//Account deletion
const AccountDeletion = lazy(() =>import("../views/AccountDelete/AccountDelete"));
const DeleteSuccess = lazy(() => import("../views/AccountDelete/Success"));

const SimpleRouter = memo(() => {
  return (
    <Suspense fallback={<Loading />}>
      <Switch>
        {/* auth */}
        <Route exact path="/auth/sign-in" component={SignIn} />
        <Route exact path="/auth/sign-up" component={SignUp} />
        <Route exact path="/auth/privacy-policy" component={PrivacyPolicy} />

        {/* Account Deletion */}
        <Route exact path="/danger/delete-account" component={AccountDeletion}/>
        <Route exact path="/account/delete-success" component={DeleteSuccess} />

        {/* error */}
        <Route exact path="/errors/error404" component={Error404} />
        <Route exact path="/errors/error500" component={Error500} />
        <Route exact path="/errors/maintenance" component={Maintenance} />
      </Switch>
    </Suspense>
  );
});

SimpleRouter.displayName = "SimpleRouter";
export default SimpleRouter;
